export default __webpack_public_path__ + "static/media/review-1.cad5d56f.jpg";